module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', {
    staticClass: "message-area"
  }, [_c('tr', {
    staticClass: "data_row"
  }, [_c('td', {
    staticClass: "openclosetd"
  }, [_c('div', {
    staticClass: "openclosebutton",
    on: {
      "click": _vm.show_hide_row
    }
  })]), _c('td', [_c('label', [_vm._v(_vm._s(_vm.data.title))])]), _c('td', [_c('label', [_vm._v(_vm._s(_vm.data.client_name)), _c('br'), _vm._v(_vm._s(_vm.data.client_mail))])]), _c('td', [_c('label', {
    domProps: {
      "innerHTML": _vm._s(_vm.inquiryDate)
    }
  })]), _c('td', {
    staticClass: "center"
  }, [_c('label', [_vm._v(_vm._s(_vm.data.total) + " 件")])]), _c('td', {
    staticClass: "center"
  }, [(_vm.data.status == 1) ? _c('label', [_vm._v("未対応")]) : _vm._e(), (_vm.data.status == 2) ? _c('label', [_vm._v("対応中")]) : _vm._e(), (_vm.data.status == 3) ? _c('label', [_vm._v("対応済")]) : _vm._e(), (_vm.data.status == 90) ? _c('label', [_vm._v("対応不要")]) : _vm._e()]), _c('td', {
    staticClass: "center"
  }, [_c('label', [_vm._v(_vm._s(_vm.data.user_name))])]), _c('td', {
    staticClass: "tags"
  }, [_c('label', [_vm._v(_vm._s(_vm.data.strTag))])])]), _c('tr', {
    staticClass: "hidden_row"
  }, [_c('td', {
    staticClass: "messagedetail",
    attrs: {
      "colspan": "8"
    }
  }, [_c('p', [_vm._v("※各項目が入力・変更後、リアルタイムで保存されます")]), _c('hr'), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('label', {
    staticClass: "pull-left"
  }, [_vm._v("件名")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.title),
      expression: "data.title"
    }],
    staticClass: "title form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "title", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('label', [_vm._v("送信元  " + _vm._s(_vm.data.client_name) + " (" + _vm._s(_vm.data.client_mail) + ")")])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', [_vm._v("内容")]), _c('pre', _vm._l((_vm.data.data), function(json, data_index) {
    return _c('div', {
      staticClass: "list-box"
    }, [_c('div', {
      staticClass: "data-caption"
    }, [_vm._v(_vm._s(json.caption) + " : ")]), _c('div', {
      staticClass: "data-value"
    }, [_vm._v(_vm._s(json.value))])])
  }))])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('label', {
    staticClass: "taglabel"
  }, [_vm._v("タグ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.strTag),
      expression: "data.strTag"
    }],
    staticClass: "typeahead",
    attrs: {
      "type": "text",
      "data-role": "tagsinput"
    },
    domProps: {
      "value": (_vm.data.strTag)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "strTag", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('label', [_vm._v("備考")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.remark),
      expression: "data.remark"
    }],
    staticClass: "remarks",
    attrs: {
      "rows": "3"
    },
    domProps: {
      "value": (_vm.data.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "remark", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', [_vm._v("状況")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.status),
      expression: "data.status"
    }],
    staticClass: "searchselect selectitems",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("未対応")]), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("対応中")]), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("対応済")]), _c('option', {
    attrs: {
      "value": "90"
    }
  }, [_vm._v("対応不要")])]), _c('label', [_vm._v("担当者")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.user_id),
      expression: "data.user_id"
    }],
    staticClass: "searchselect selectitems",
    attrs: {
      "name": "user"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "user_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "null"
    }
  }, [_vm._v("---")]), _vm._l((_vm.members), function(member) {
    return _c('option', {
      domProps: {
        "value": member.id
      }
    }, [_vm._v(_vm._s(member.name))])
  })], 2)])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('button', {
    staticClass: "customsmallbutton btn btn-success",
    attrs: {
      "data-action": "open",
      "data-side": "right",
      "type": "button",
      "name": "chat"
    },
    on: {
      "click": _vm.showHistory
    }
  }, [_vm._v("履歴表示")]), _c('button', {
    staticClass: "customsmallbutton btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.print
    }
  }, [_vm._v("印 刷")]), _c('button', {
    staticClass: "customsmallbutton btn deletebutton btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.delInquiry
    }
  }, [_vm._v("削 除")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f96d0fac","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/message/Message.vue
// module id = 616
// module chunks = 1